<template>
  <div class="winners page-block position-relative" id="winners-block">
    <div class="container-xl">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="mx-auto text-white">{{tr('winners-title')}}</h2>
          <p class="text-white">A feltüntetett nyertesek nem képezik a teljes nyerteslistát, csupán annak egy részét jelenítik meg.</p>
        </div>
        <div class="col-12">
          <div class="winners-block__inner mt-5">
            
            <!-- TAB -->
            <div class="winners-button-select justify-content-center" >
               <button class="mx-3 mb-2 mb-md-0"
                :class="{'active':winnerState === 'main'}" 
                v-on:click="setWinnerState('main');setGTM('nyertesek_main')"
              >Fődíj nyertese
              </button>
              <button class="mx-3 mb-2 mb-md-0"
                :class="{'active':winnerState === 'utalvany_80'}" 
                v-on:click="setWinnerState('utalvany_80');setGTM('nyertesek_utalvany_80')"
              >
                80.000 Ft
              </button>
              <button class="mx-3 mb-2 mb-md-0"
                :class="{'active':winnerState === 'utalvany_40'}" 
                 v-on:click="setWinnerState('utalvany_40');setGTM('nyertesek_utalvany_40')"
              >
                40.000 Ft
              </button> 
              <button class="mx-3 mb-2 mb-md-0"
                :class="{'active':winnerState === 'utalvany_20'}" 
                v-on:click="setWinnerState('utalvany_20');setGTM('nyertesek_utalvany_20')"
              >
                20.000 Ft
              </button>          
             
            </div>
            <!-- TAB - MOBILE -->
            <div class="dropdown winners-button-select--mobile text-center d-none">
              <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                  <span v-if="winnerState == 'main'">{{tr('winners-tab-3')}}</span>
                  <span v-if="winnerState == 'utalvany_80'">80.000 Ft</span>
                  <span v-if="winnerState == 'utalvany_40'">40.000 Ft</span>
                  <span v-if="winnerState == 'utalvany_20'">20.000 Ft</span>
                 <!-- <span v-else-if="winnerState == 'weekly'">{{tr('winners-tab-2')}}</span>
                  <span v-else>{{tr('winners-tab-1')}}</span>-->
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"> 
                <div class="dropdown-item" v-on:click="setWinnerState('main');setGTM('main')">{{tr('winners-tab-3')}}</div>
                <div class="dropdown-item" v-on:click="setWinnerState('utalvany_80');setGTM('utalvany_80')">80.000 Ft</div>
                <div class="dropdown-item" v-on:click="setWinnerState('utalvany_40');setGTM('utalvany_40')">40.000 Ft</div>
                <div class="dropdown-item" v-on:click="setWinnerState('utalvany_20');setGTM('utalvany_20')">20.000 Ft</div>
              </div>
            </div>                   
            <div class="separator"></div>

            <!-- TABLE -->
            <div class="winners-wrap" v-if="filteredWinners && filteredWinners.length">
              <div class="winners__item">
                <CatGallery
                  :items="filteredWinners" :isFinalist="this.winnerState === 'main'"
                />
              </div>
            </div>
            <div class="col-12 text-center col-lg-6 offset-lg-3" v-else>
                <p class="fs-24 py-4" style="color: #F8BBD6;border-top: 2px solid #780068; border-bottom: 2px solid #780068;" v-if="this.winnerState === 'main'">A nyertes hamarosan kiderül!</p>
                <p v-else class="fs-24 py-4" style="color: #F8BBD6;border-top: 2px solid #780068; border-bottom: 2px solid #780068;">Nyertesek hamarosan!</p>
            </div>
            <div class="d-flex justify-content-center pt-4" v-if="needMoreBtn">
              <button type="button" class="btn btn-primary" v-on:click="moreWinners(true)"> {{tr("winners-more-btn")}}</button>
            </div>

          </div>
          
        </div>
        
        <div class="col-12 col-lg-8 offset-lg-2">
          <p class="winners-more-text">{{tr("winners-info-text")}}  </p>
        </div>
      </div>
    </div>    
  </div>
</template>

<script>
import promoStatus from "@/config/promoStatus";
import CatGallery from './CatGallery.vue'

export default {
  components: { CatGallery },
  data() {
    return {
      winnerState: "main",
      winnerTypes: {
        napi: "Napi nyertes",
        weekly: "weekly nyertes",
        main: 'Fődíj nyertes'
      },
      winnings:{
        daily: this.tr('winning-type-daily'),
        weekly: this.tr('winning-type-weekly'),
        main: this.tr('winning-type-main')
      },
      needMoreBtn: false,
      needMoreWinners: false
    }
  },
  computed: {

    promotionIsActive() {
      return this.$store.state.promoStatus === promoStatus.live;
    },
    promotionIsBefore() {
      return this.$store.state.promoStatus === promoStatus.before;
    },
    promotionIsAfter() {
      return this.$store.state.promoStatus === promoStatus.after;
    },
    filteredWinners() {
        let result;
        
        console.log(this.$store.state.winnersAll);
        if(this.$store.state.winnersAll ?? []){
            result = this.$store.state.winnersAll.filter(w => w.type === this.winnerState)

            console.log(result);
            if(result.length > 10 && !this.needMoreWinners){
                this.checkBtn(true);
                return result.slice(0,10);
            }else{
                this.checkBtn(false);
                return result;
            }
        }
        this.checkBtn(false);
        return result;
    }
  },
  created() {
    this.$store.dispatch("getWinners");    
  },
  methods: {
    setGTM(item){

      this.GTtrackGA4({
        'event' : 'event',
        'category': 'nyertesek',
        'action': 'kattintas',
        'label': item,
        'clicked_text':item,
        'action_type': 'nyertesek_kattintas'
      })
    },
    setWinnerState(newState) {
        this.winnerState = newState;
        this.moreWinners(false);      
    },
    checkBtn(newState) {
        this.needMoreBtn = newState;
    },
    moreWinners(newState){
        this.needMoreWinners = newState;
    }
  }
}
</script>